import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const PROGRAM_BASE_URL =
  `${API_BASE_URL}/programs`;

// ==================================================
// GET PROGRAM FEED
//
// Guest:
// GET /programs/feed
//
// Logged-in:
// GET /programs/feed?user_id=43
// ==================================================
export const getTodayEventsApi = async (
  user_id?: number | string | null
) => {
  try {
    const params: Record<string, any> = {};

    if (
      user_id !== undefined &&
      user_id !== null &&
      String(user_id).trim() !== "" &&
      Number(user_id) > 0
    ) {
      params.user_id = Number(user_id);
    }

    const res = await axios.get(
      `${PROGRAM_BASE_URL}/feed`,
      {
        params,
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      status: false,
      data: [],
      message:
        error?.response?.data?.message ||
        "Failed to fetch programs",
    };
  }
};

// ==================================================
// OPTIONAL CLEAR NAME FOR NEW CODE
// Same API as getTodayEventsApi
// ==================================================
export const getProgramFeedApi = async (
  user_id?: number | string | null
) => {
  return getTodayEventsApi(user_id);
};
